<template>
    <section class="pt-5 pt-md-9" id="service">
  
  <div class="container">
    <div class="position-absolute z-index--1 end-0 d-none d-lg-block"><img src="../../assets/img/category/shape.svg" style="max-width: 200px" alt="service" /></div>
    <div class="mb-7 text-center">
      <h5 class="text-secondary">CATEGORY </h5>
      <h3 class="fs-xl-10 fs-lg-8 fs-7 fw-bold font-cursive text-capitalize">Top Four in Season</h3>
    </div>
    <div class="row">
      <div class="col-lg-3 col-sm-6 mb-6">
        <div class="card service-card shadow-hover rounded-3 text-center align-items-center">
          <div class="card-body p-xxl-5 p-4"> <img src="https://cdn-icons-png.flaticon.com/512/10504/10504744.png" width="75" alt="Service" />
            <h4 class="mb-3">White Sand</h4>
            <p class="mb-0 fw-medium">This is a beautiful and inexpensive beachside location that makes optimal use of the surrounding trees and beautiful white sand.</p>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-sm-6 mb-6">
        <div class="card service-card shadow-hover rounded-3 text-center align-items-center">
          <div class="card-body p-xxl-5 p-4"> <img src="https://www.shareicon.net/data/512x512/2015/09/20/643595_tree_512x512.png" width="75" alt="Service" />
            <h4 class="mb-3">Black sand</h4>
            <p class="mb-0 fw-medium">Experience the stunning beauty of Iceland's South Coast on a Gray Line tour. See awe-inspiring waterfalls and black sand beaches</p>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-sm-6 mb-6">
        <div class="card service-card shadow-hover rounded-3 text-center align-items-center">
          <div class="card-body p-xxl-5 p-4"> <img src="https://cdn-icons-png.flaticon.com/512/4113/4113006.png" width="75" alt="Service" />
            <h4 class="mb-3">Walk Hike</h4>
            <p class="mb-0 fw-medium">The treks will take you to the very famous World Heritage Sites, beautiful national parks, impressive highlands and traditional little villages.</p>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-sm-6 mb-6">
        <div class="card service-card shadow-hover rounded-3 text-center align-items-center">
          <div class="card-body p-xxl-5 p-4"> <img src="https://cdn-icons-png.flaticon.com/512/0/278.png" width="75" alt="Service" />
            <h4 class="mb-3">Vehicle Hike</h4>
            <p class="mb-0 fw-medium">A wide variety of trekking tours through rain forest patches, across paddy fields, rail roads & tunnels, tea estates, mountain, valleys, grassy plains.</p>
          </div>
        </div>
      </div>
    </div>
  </div><!-- end of .container-->
  
  </section>
  </template>
  
  <script>
  export default {
      name : 'CategoryPage',
  }
  </script>
  
  <style>
  
  </style>